import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';

@Module({
	namespaced: true
})
export default
class GlobalWorkspaceStoreModule extends VuexModule {

	global = false;

	@Mutation
	setGlobal(isGlobal: boolean): void {
		this.global = isGlobal;
	}

	@Action({ commit: 'setGlobal' })
	setToGlobal(): boolean {
		return true;
	}

	@Action({ commit: 'setGlobal' })
	setToNonGlobal(): boolean {
		return false;
	}

	get isGlobal(): boolean {
		return this.global;
	}
}
